import React from 'react';
import { 
  BarChart3, 
  PieChart, 
  Users, 
  Settings, 
  Search,
  TrendingUp,
  UserCheck,
  Calendar,
  Database,
  Upload,
  LogOut
} from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

interface SidebarProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ activeTab, onTabChange }) => {
  const { userEmail, signOut } = useAuth();
  const menuItems = [
    { id: 'overview', label: '概要', icon: BarChart3 },
    // { id: 'insights', label: 'Insights', icon: TrendingUp },
    // { id: 'users', label: 'ユーザー', icon: Users },
    { id: 'groups', label: 'グループ', icon: UserCheck },
    // { id: 'providers', label: 'Providers', icon: Database },
    // { id: 'reports', label: 'Reports', icon: Calendar },
    // { id: 'upload', label: 'Upload', icon: Upload },
    { id: 'settings', label: '設定', icon: Settings },
  ];

  return (
    <div className="w-64 bg-white border-r border-gray-200 h-screen flex flex-col">
      {/* Logo */}
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
            <PieChart className="w-5 h-5 text-white" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-gray-900">SaaSモニター</h1>
            <p className="text-sm text-gray-500">コスト管理</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4">
        <div className="space-y-1">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = activeTab === item.id;
            
            return (
              <button
                key={item.id}
                onClick={() => onTabChange(item.id)}
                className={`w-full flex items-center space-x-3 px-3 py-2 rounded-lg text-left transition-colors ${
                  isActive
                    ? 'bg-primary-50 text-primary-700 border border-primary-200'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                }`}
              >
                <Icon className={`w-5 h-5 ${isActive ? 'text-primary-600' : 'text-gray-400'}`} />
                <span className="font-medium">{item.label}</span>
              </button>
            );
          })}
        </div>
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-gray-200">
        <div className="mb-3">
          <p className="text-xs text-gray-500">ログイン中:</p>
          <p className="text-sm text-gray-700 truncate">{userEmail}</p>
        </div>
        <button
          onClick={signOut}
          className="w-full flex items-center space-x-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded-lg transition-colors"
        >
          <LogOut className="w-4 h-4" />
          <span>ログアウト</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;